import * as React from 'react';
import { routeConstants } from 'app/routes/route-constants';
import { SearchTileProps } from '../search-container/types';
import { SearchTile, TileLink } from 'app/components/search-tile';
import { TileInfo } from '../search-tile';
import { PersonMeatballMenu } from 'app/area/administration/list/components/person-meatball-menu';
import { getVeracityCompanyAdministrationLink, isVeracityEnabled } from 'app/infrastructure/hosting';
import { ids } from 'app/area/administration/constants';
import { MeatballMenu, Link } from 'ui';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { isDisabled } from 'app/infrastructure/data/date';
import { Tag } from 'app/components/tag';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './user-tile.scss';

export const UserTile: React.FC<SearchTileProps> = props => {

  const { data, itemPersonAccess, canDuplicate, onDelete, onLoadPersonAccess: onLoadPersonAccess,
    onClearPersonAccess, translation, showMeatball, mergeUser, updateMergeUser } = props;

  const veracityCompanyAdministrationLink = getVeracityCompanyAdministrationLink();

  return <SearchTile
    componentId={ids.search.tile}
    footer={<TileInfo
      id={data.id}
      personId={data.personId}
      email={data.emailAddress}
      mainGroup={data.mainUserGroup}
      role={data.role && data.role.v !== 0 && data.role.d} />}
    deleted={data.deleted}>

    <div className={styles.content}>
      <div className={styles.leftSide}>
        <TileLink
          url={routeConstants.userEditFor(data.id)}
          title={data.name} />
      </div>
      <div className={styles.rightSide}>
        {isDisabled(new Date(data?.disabled)) ? <Tag className={styles.tag}>{translation.disabled}</Tag> : null}
        {data?.technical ? <Tag className={styles.tag}>{translation.technical_user}</Tag> : null}
      </div>
    </div>

    {!isVeracityEnabled() && showMeatball && <PersonMeatballMenu
      id={data.id}
      name={data.name}
      personId={data.personId}
      technical={data.technical}
      isUser={true}
      itemPersonAccess={itemPersonAccess}
      canDuplicate={canDuplicate}
      onDuplicate={routeConstants.userDuplicateFor}
      labelDuplicate={translation.duplicate_user}
      labelDeleteTitle={data.technical ? translation.technical_user_delete_title : translation.delete_user_title}
      labelDelete={translation.delete_item}
      labelContinue={data.technical ? translation.technical_user_delete_confirmation : translation.delete_item}
      labelCancel={translation.cancel}
      labelDescription={
        replaceTemplateString(data.technical ? translation.technical_user_delete_description : translation.delete_user_desc,
          data.name)}
      labelNoAccess={translation.no_access_has_been_granted}
      onDelete={onDelete}
      onLoadPersonAccess={onLoadPersonAccess}
      onClearPersonAccess={onClearPersonAccess}
      mergeUser={mergeUser}
      updateMergeUser={updateMergeUser}
      translation={translation} />}
    {
      isVeracityEnabled() && !!veracityCompanyAdministrationLink &&
      <MeatballMenu className={styles.meatball} id={ids.list_search_item(data.id)} closeAfterClick={true}>
        <li>
          <Tooltip title={translation.veracity_redirect_info} className={styles.tooltip} narrow={true}>
            <Link componentId={ids.users.invite_veracity_user_button} url={veracityCompanyAdministrationLink}
              className="dropdown-item">
              {translation.delete_item}
            </Link>
          </Tooltip>
        </li>
      </MeatballMenu>
    }
  </SearchTile>;
};
